import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { parseJwt } from "../components/utilities/utils";
import { BASE_URLS, PLATFORM_TYPE } from "../constants/constants";
let userDetails = localStorage.getItem("access_token")
  ? parseJwt(localStorage.getItem("access_token"))
  : {};

let { authorizedDistricts, authorizedStates, authorizedAcs } = userDetails;
export const commonApi = createApi({
  reducerPath: "commonApi",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URLS.COMMON_SERVICES_BASE_URL,
    prepareHeaders: (headers) => {
      headers.set("authorization", `Bearer ${localStorage.access_token}`);
      headers.set("PLATFORM-TYPE", PLATFORM_TYPE);
      if (localStorage.userrole !== undefined) {
        headers.set("currentRole", localStorage.userrole);
        headers.set("atkn_bnd", localStorage?.atkn_bnd);
      headers.set("rtkn_bnd", localStorage?.rtkn_bnd);
      headers.set("channelidobo", "ETPBMS");
      }
      if (localStorage.userrole !== "eci" && authorizedStates?.length) {
        headers.set("state", "master");
        headers.set("atkn_bnd", localStorage?.atkn_bnd);
      headers.set("rtkn_bnd", localStorage?.rtkn_bnd);
      headers.set("channelidobo", "ETPBMS");
      }
      return headers;
    },
  }),
  keepUnusedDataFor: 5,
  endpoints: (builder) => ({
    GetStatesRequest: builder.query({
      query: () => ({
        headers: {
          Authorization: "Bearer " + localStorage.access_token,
        },
        url: "../../api/v1/common/states/",
        method: "Get",
      }),
      providesTags: ["Form7"],
    }),
    GetCountriesRequest: builder.query({
      query: () => ({
        headers: {
          Authorization: "Bearer " + localStorage.access_token,
        },
        url: "/api/v1/common/countries",
        method: "Get",
      }),
      providesTags: ["Form7"],
    }),

    GetStateByCountryCodeRequest: builder.query({
      query: (countryCode) => ({
        headers: {
          Authorization: "Bearer " + localStorage.access_token,
        },
        url: `/api/v1/common/get/states/byCountry?countryCd=${countryCode}`,
        method: "Get",
      }),
      providesTags: ["Form6a"],
    }),

    GetOverseasCountriesRequest: builder.query({
      query: (stateCode) => ({
        headers: {
          Authorization: "Bearer " + localStorage.access_token,
          state: "master",
        },
        url: "/api/v1/common/overseasCountries",
        method: "Get",
      }),
      providesTags: ["Form7"],
    }),

    GetDistrictRequest: builder.query({
      query: (stateCode) => ({
        headers: {
          Authorization: "Bearer " + localStorage.access_token,
          state: parseJwt(localStorage.access_token).authorizedStates[0],
        },
        url: `/api/v1/common/districts/${stateCode}`,
        method: "Get",
      }),
      providesTags: ["Form6a"],
    }),

    GetAcsRequest: builder.query({
      query: (districtCode) => ({
        headers: {
          Authorization: "Bearer " + localStorage.access_token,
          state: parseJwt(localStorage.access_token).authorizedStates[0],
        },
        url: `/api/v1/common/acs/${districtCode}`,
        method: "Get",
      }),
      providesTags: ["Form7"],
    }),

    GetConstituencyRequest: builder.query({
      query: (stateCode) => ({
        // headers: {
        //   Authorization: "Bearer " + localStorage.access_token,
        // },
        url: `/api/v1/common/constituencies?stateCode=${stateCode}`,
        method: "Get",
      }),
      providesTags: ["Form6a"],
    }),

    GetPartRequest: builder.query({
      query: (acNumber) => ({
        headers: {
          Authorization: "Bearer " + localStorage.access_token,
          state: parseJwt(localStorage.access_token).authorizedStates[0],
        },
        url: `/api/v1/common/parts/${acNumber}`,
        method: "Get",
      }),
      providesTags: ["Form7"],
    }),

    getAcs: builder.query({
      query: (districtId) => ({
        headers: {
          Authorization: "Bearer " + localStorage.access_token,
          state: parseJwt(localStorage.access_token).authorizedStates[0],
        },
        url: `api/v1/common/acs/${districtId}`,
        method: "GET",
      }),
    }),

    getParts: builder.query({
      query: (details) => {
        let districtcode = details.districtCode
          ? `&districtCd=${details.districtCode}`
          : "";
        return {
          headers: {
            Authorization: "Bearer " + localStorage.access_token,
            state: parseJwt(localStorage.access_token).authorizedStates[0],
          },
          url: `api/v1/common/part/get/bystatecd/districtcd/acNumber?acNumber=${details.acNumber}&stateCd=${details.stateCode}`,
          method: "GET",
        };
      },
    }),

    getParam: builder.query({
      query: ({ parameterType, state }) => ({
        url: `api/v1/common/getParam?parameterType=${parameterType}`,
        method: "GET",
        headers: {
          state: state,
        },
      }),
    }),

    getSections: builder.query({
      query: (details) => ({
        headers: {
          Authorization: "Bearer " + localStorage.access_token,
          state: parseJwt(localStorage.access_token).authorizedStates[0],
        },
        url: `api/v1/common/section/get/acNo/partNo?acNo=${details.acNumber}&partNo=${details.partNo}`,
        method: "GET",
      }),
    }),

    getPartNameById: builder.query({
      query: (details) => {
        let districtcode = details.districtCode
          ? `/${details.districtCode}`
          : "";
        return {
          headers: {
            Authorization: "Bearer " + localStorage.access_token,
            state: details.stateheader,
          },
          url: `api/v1/common/get/partName/${details.districtCode}/${details.acNumber}/${details.partNo}`,
          method: "GET",
        };
      },
    }),

    getSectionNameById: builder.query({
      query: (details) => {
        let districtcode = details.districtCode
          ? `/${details.districtCode}`
          : "";
        return {
          headers: {
            Authorization: "Bearer " + localStorage.access_token,
            state: details.stateheader,
          },
          url: `api/v1/common/get/sectionName/${details.districtCode}/${details.acNumber}/${details.partNo}/${details.sectionNo}`,
          method: "GET",
        };
      },
    }),
    // GetVoterStatus: builder.query({
    //   query: ({ epicNumber, statecd, acno }) => ({
    //     headers: {
    //       Authorization: "Bearer " + localStorage.access_token,
    //       // state: parseJwt(localStorage.access_token).authorizedStates[0],
    //       currentRole: localStorage.userrole
    //     },
    //     url: `/api/v1/dVoter/checkDvoterByEpic/${epicNumber}?stateCode=${statecd}&acNo=${acno}`,
    //     method: "Get",
    //   }),
    // }),
    GetVoterStatus: builder.mutation({
      query: (data) => ({
        headers: {
          Authorization: "Bearer " + localStorage.access_token,
          // state: parseJwt(localStorage.access_token).authorizedStates[0],
          currentRole: localStorage.userrole,
        },
        url: "/api/v1/dVoter/checkDvoterByEpic",
        body: data,
        method: "POST",
      }),
    }),

    getMultiAcs: builder.query({
      query: ({ ac, state }) => ({
        headers: {
          Authorization: "Bearer " + localStorage.access_token,
          state: state,
        },
        url: `../../api/v1/common/get/districts/forMultipleAC?acNo=${ac}&stateCd=${state}`,
        method: "Get",
      }),

      providesTags: ["Form7"],
    }),
    GetACbyPC: builder.query({
      query: (data) => ({
        headers: {
          Authorization: "Bearer" + localStorage.access_token,
          state: "S04",
        },
        url: `/api/v1/common/getAcFromAcPc?pcNo=${data.pcNo}&stateCd=${data.stateCd}`,
        method: "Get",
      }),
      // providesTags: ["Form6a"],
    }),
    GetPcByState: builder.query({
      query: (data) => ({
        headers: {
          state: "master",
        },
        url: `/api/v1/common/pc/get/bystatecd/districtcd/parliamentNo?stateCd=${data}`,
        method: "Get",
      }),
      // providesTags: ["Form6a"],
    }),
  }),
});

export const {
  useGetStatesQuery,
  useGetDistrictQuery,
  useGetStateByCountryCodeRequestQuery,
  useGetCountriesRequestQuery,
  useGetOverseasCountriesRequestQuery,
  useGetParamQuery,
  useGetAcsQuery,
  useGetPartsQuery,
  useGetSectionsQuery,
  useGetPartNameByIdQuery,
  useGetSectionNameByIdQuery,
  useGetStatesRequestQuery,
  useGetDistrictRequestQuery,
  useGetPartRequestQuery,
  useGetConstituencyRequestQuery,
  // useGetVoterStatusQuery,
  useGetMultiAcsQuery,
  useGetVoterStatusMutation,
  useGetACbyPCQuery,
  useGetPcByStateQuery
} = commonApi;
